"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNewebPayDecryptRequest = instanceOfNewebPayDecryptRequest;
exports.NewebPayDecryptRequestFromJSON = NewebPayDecryptRequestFromJSON;
exports.NewebPayDecryptRequestFromJSONTyped = NewebPayDecryptRequestFromJSONTyped;
exports.NewebPayDecryptRequestToJSON = NewebPayDecryptRequestToJSON;
exports.NewebPayDecryptRequestToJSONTyped = NewebPayDecryptRequestToJSONTyped;
/**
 * Check if a given object implements the NewebPayDecryptRequest interface.
 */
function instanceOfNewebPayDecryptRequest(value) {
    if (!('tradeInfo' in value) || value['tradeInfo'] === undefined)
        return false;
    if (!('tradeSha' in value) || value['tradeSha'] === undefined)
        return false;
    return true;
}
function NewebPayDecryptRequestFromJSON(json) {
    return NewebPayDecryptRequestFromJSONTyped(json, false);
}
function NewebPayDecryptRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tradeInfo': json['tradeInfo'],
        'tradeSha': json['tradeSha'],
    };
}
function NewebPayDecryptRequestToJSON(json) {
    return NewebPayDecryptRequestToJSONTyped(json, false);
}
function NewebPayDecryptRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tradeInfo': value['tradeInfo'],
        'tradeSha': value['tradeSha'],
    };
}
